<lm-facade-modules
  [state]="state"
  [moduleFacades]='moduleFacades'
  [style.display]="showModuleFacadeBCComponent() ? 'none' : 'block'"
  (moduleSelected)="moduleSelected($event)"
  (startedSelected)="startedSelected($event)">
</lm-facade-modules>
<div class="lm-facade-module-content"
  [style.width]="moduleWidth()"
  [style.display]="showModuleFacadeBCComponent() ? 'none' : 'block'">
  <lm-facade-module-header
    [state]="state"
    [showWelcome]="showWelcome()"
    [moduleFacades]="moduleFacades"
    [style.display]="showModuleFacadeBCComponent() ? 'none' : 'block'"
    (search)="handleSearch($event)">
  </lm-facade-module-header>
  <lm-facade-module
    [state]="state"
    [suggestedBusinessObjects]="suggestedBusinessObjects"
    [suggestedTemplates]="suggestedTemplates"
    [selectedModule]="selectedModule"
    [style.display]="showModuleFacadeBCComponent() || showSearchResultsPanel() ? 'none' : 'block'"
    [style.height]="(showWelcome() && !state.hideWelcome) ? 'calc(100% - 283px)' : 'calc(100% - 80px)'"
    (openModuleFacadeBC)="openModuleFacadeBCComponent($event)"
    (startFromScratch)="openStartFromScratch($event)"
    (templateDetails)="toggleTemplateDetails($event)">
  </lm-facade-module>
  @if (showSearchResultsPanel()) {
    <lm-facade-search-results
      [searchTerms]="searchTerms"
      [businessObjects]="searchResultsBusinessObjects"
      [templates]="searchResultsTemplates"
      [style.display]="showModuleFacadeBCComponent() ? 'none' : 'block'"
      (openModuleFacadeBC)="openModuleFacadeBCComponent($event)"
      (templateDetails)="toggleTemplateDetails($event)">
    </lm-facade-search-results>
  }
</div>

@if (showModuleFacadeBCComponent()) {
  <lm-facade-business-object
    [options]="businessObjectOptions"
    (closeBo)="closeModuleFacadeBCComponent($event)"
  ></lm-facade-business-object>
}